/*
 * @Author: your name
 * @Date: 2022-04-09 21:23:48
 * @LastEditTime: 2022-04-09 21:25:45
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \wap\src\utils\crypto-service.js
 */
import CryptoJS from 'crypto-js'

// 默认的 KEY 与 IV
const KEY = CryptoJS.enc.Utf8.parse('com.cartisan.www')
const IV = CryptoJS.enc.Utf8.parse('com.cartisan.www')

export class CryptoService{
    encrypt(content, keyStr = '', ivStr = '') {
    let key = KEY
    let iv = IV

    if (keyStr) {
        key = CryptoJS.enc.Utf8.parse(keyStr)
        iv = CryptoJS.enc.Utf8.parse(ivStr)
    }

    const srcs = CryptoJS.enc.Utf8.parse(content)
    var encrypted = CryptoJS.AES.encrypt(srcs, key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.ZeroPadding
    })

    return CryptoJS.enc.Base64.stringify(encrypted.ciphertext)
}
  
decrypt(content, keyStr = '', ivStr = '') {
    let key = KEY
    let iv = IV
  
    if (keyStr) {
      key = CryptoJS.enc.Utf8.parse(keyStr)
      iv = CryptoJS.enc.Utf8.parse(ivStr)
    }
  
    const base64Content = CryptoJS.enc.Base64.parse(content)
    const srcs = CryptoJS.enc.Base64.stringify(base64Content)
  
    const decrypted = CryptoJS.AES.decrypt(srcs, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.ZeroPadding
    })
  
    return decrypted.toString(CryptoJS.enc.Utf8)
  }
}
export default new CryptoService()